export default __webpack_public_path__ + "static/31-41 Rajaram et al-92ad870f5b945f5d9323cb59fa199593.pdf";